import { useMemo } from 'react';
import { unselect } from '../unselect.js';
export const useListNavigationHandlers = ({ items, onActiveItemChange, activeItem, }) => {
    const index = activeItem === unselect ? -1 : items.indexOf(activeItem);
    const end = items.length - 1;
    return useMemo(() => ({
        onHome: () => onActiveItemChange(items[0]),
        onEnd: () => onActiveItemChange(items[end]),
        onDown: () => onActiveItemChange(items[(index + 1) % items.length]),
        onUp: () => onActiveItemChange(items[index === -1 ? end : (index - 1 + items.length) % items.length]),
    }), [onActiveItemChange, items, end, index]);
};
//# sourceMappingURL=useListNavigationHandlers.js.map